import * as types from "./types.js"
import * as api from "./api.js"


function getRatingsRequest() {
    return {
        type: types.GET_RATINGS_REQUEST
    }
}

function getRatingsReceived(ratings) {
    return {
        type: types.GET_RATINGS_RECEIVED,
        payload: ratings
    }
}

function getRatingsError(e) {
    return {
        type: types.GET_RATINGS_ERROR,
        payload: e,
        error: true
    }
}

export function getRatings(personid) {
    return dispatch => {
        dispatch(getRatingsRequest())
        return api.getRatings(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getRatingsError(res.statusText))
            } else {
                return res.json()
                .then(ratings => {
                    dispatch(getRatingsReceived(ratings))
                })
            }
        })
    }
}


function postRatingRequest() {
    return {
        type: types.POST_RATING_REQUEST
    }
}

function postRatingReceived(rating) {
    return {
        type: types.POST_RATING_RECEIVED,
        payload: rating
    }
}

function postRatingError(e) {
    return {
        type: types.POST_RATING_ERROR,
        payload: e,
        error: true
    }
}

export function postRating(rating) {
    return dispatch => {
        dispatch(postRatingRequest())
        return api.postRating(rating)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postRatingError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postRatingReceived({
                        id: stats.id,
                        rating: rating.rating,
                        rank: rating.rank,
                        hours: rating.hours,
                        rate: rating.rate,
                        details: rating.details,
                        valid: rating.valid
                    }))
                })
            }
        })
    }
}


function putRatingRequest() {
    return {
        type: types.PUT_RATING_REQUEST
    }
}

function putRatingReceived(rating) {
    return {
        type: types.PUT_RATING_RECEIVED,
        payload: rating
    }
}

function putRatingError(e) {
    return {
        type: types.PUT_RATING_ERROR,
        payload: e,
        error: true
    }
}

export function putRating(rating) {
    return dispatch => {
        dispatch(putRatingRequest())
        return api.putRating(rating)
        .then(res => {
            if (res.status !== 200) {
                dispatch(putRatingError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(putRatingReceived({
                        id: rating.id,
                        rating: rating.rating,
                        rank: rating.rank,
                        hours: rating.hours,
                        rate: rating.rate,
                        details: rating.details,
                        valid: rating.valid
                    }))
                })
            }
        })
    }
}


function deleteRatingRequest() {
    return {
        type: types.DELETE_RATING_REQUEST
    }
}

function deleteRatingReceived(rating) {
    return {
        type: types.DELETE_RATING_RECEIVED,
        payload: rating
    }
}

function deleteRatingError(e) {
    return {
        type: types.DELETE_RATING_ERROR,
        payload: e,
        error: true
    }
}

export function deleteRating(id) {
    return dispatch => {
        dispatch(deleteRatingRequest())
        return api.deleteRating(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteRatingError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteRatingReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/ratings/actions.js
 **/